import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import ConfigModal from "./ConfigModal"
import ConfigMain from "../Config/ConfigMain"
import { useQuery } from "@apollo/client"
import { GET_GLOBAL_SETTINGS } from "../../api/QuadriApi"
import "./ObjectModelConfig.css"
import { useHistory } from "react-router-dom"

interface ConfigMainStartProps {
  quadriEnabled: boolean
  submitQuadriProject: (e: any) => void
  openClassicUI?: boolean
}

const ConfigMainStart: React.FC<ConfigMainStartProps> = (props) => {
  const history = useHistory()
  const { t } = useTranslation("config")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const [redirectToClassicUI, setRedirectToClassicUI] = useState(false)

  const openModalOrRedirect = () => {
    if (props.openClassicUI) {
      history.replace("/config")
    } else {
      setIsModalOpen(true)
    }
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const getGlobalSettingsQuery = useQuery(GET_GLOBAL_SETTINGS)

  let quadriConfigurationUiUrl
  if (getGlobalSettingsQuery.data) {
    quadriConfigurationUiUrl = getGlobalSettingsQuery.data.getGlobalSettings.quadriConfigurationFrontEndUrl
  }

  const objectModelIsEnabled = props.quadriEnabled

  if (objectModelIsEnabled) {
    return <ConfigMain />
  }

  return (
    <>
      (
      <div style={{ paddingLeft: "16px", paddingRight: "16px" }}>
        <div className="head-container">
          <div className="page-heading">
            <h1>{t("objectModelConfig.title")}</h1>
            <button
              className="button primary d-none d-lg-flex"
              onClick={openModalOrRedirect}
              data-testid="new-object-model"
            >
              {t("objectModelConfig.newButton")}
            </button>
          </div>
          <div className="row mb-5"></div>
          <div className="row justify-content-center align-items-center">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div
                className="flex-column text-center vertical-center empty-state-card"
                onClick={openModalOrRedirect}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <img
                  src={isHovered ? "Quadri_24_blue.svg" : "Quadri_24_gray.svg"}
                  height={30}
                  width={30}
                  alt={t("objectModelConfig.title")}
                  className="mb-1"
                />
                <div className="mb-1 text-semibold">{t("objectModelConfig.title")}</div>
                <p>{t("objectModelConfig.heading")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      )
      {isModalOpen && (
        <ConfigModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          quadriConfigurationUiUrl={quadriConfigurationUiUrl}
          submitQuadriProject={props.submitQuadriProject}
        />
      )}
    </>
  )
}

export default ConfigMainStart
